export const PLANO_MEDICO: string = "Plano Médico";
export const PLANO_ODONTO: string = "Plano Odontologia";
export const PLANO_TERCEIRO: string = "Rede Terceira";
